export default "__VITE_ASSET__6aeec0a9__"